import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination } from '@/components';
import { Table } from '@/ui';
import { IStockBalance } from '@/models/stockBalances.model';
import { StockBalancesFiltersProvider } from '../StockBalancesFiltersContext/StockBalancesFiltersContext';
import StockBalancesTableHeaderWrapper from '../StockBalancesTableHeaderWrapper/StockBalancesTableHeaderWrapper';
import { getStockBalancesTableColumns } from './columns';
import { StyledContentBlock } from '../styled';

const tableHeaderComponents = {
  header: {
    wrapper: StockBalancesTableHeaderWrapper,
  },
};

type TProps = {
  list: IStockBalance[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  regionOptions: { label: string; value: string }[];
  categoryOptions: { label: string; value: string }[];
  filterRevision: number;
};

const StockBalancesList = ({
  list,
  isLoading,
  currentPage,
  total,
  pageSize,
  onPageChange,
  regionOptions,
  categoryOptions,
  filterRevision,
}: TProps) => {
  const { t } = useTranslation(['stockBalances']);
  const { t: tProducts } = useTranslation('products');
  const columns = useMemo(() => getStockBalancesTableColumns({ t, tProducts, total }), [t, tProducts, total]);
  const filtersContextValue = useMemo(
    () => ({ regionOptions, categoryOptions, filterRevision }),
    [regionOptions, categoryOptions, filterRevision],
  );

  return (
    <StyledContentBlock>
      <StockBalancesFiltersProvider value={filtersContextValue}>
        <Table
          className="stock-balances-table"
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={list}
          rowKey="id"
          loading={isLoading}
          components={tableHeaderComponents}
        />
      </StockBalancesFiltersProvider>
      <Pagination current={currentPage} total={total} pageSize={pageSize} onChange={onPageChange} />
    </StyledContentBlock>
  );
};

export default StockBalancesList;
